module.exports = __webpack_public_path__ + "static/grafika8-b4528267b871472f555dc41cb17350da.png";